export default {
  PDF: 'application/pdf',
  JPEG: 'image/jpeg',
  JPG: 'image/jpeg',
  PNG: 'image/png',
};
